import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import verifyIcon from "../../../assets/icons/verified.svg";
import "../modal.css";
import { useDispatch } from "react-redux";
import { sendMail } from "../../../redux/actions/manufacturerActions";
import MailSent from "../../popups/MailSent";
import SuccessPopup from "../../popups/SuccessPopup";
import ErrorPopup from "../../popups/ErrorPopup";

const SendMailModal = ({ show, handleClose, data, fetchManufacturerList }) => {
  const dispatch = useDispatch();
  const [mailSent, setMailSent] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();

  const sendMailFnc = () => {
    dispatch(
      sendMail(
        {
          vendor_id: data?.id,
        },
        onSuccess,
        onError
      )
    );
  };

  const timeOutFnc = () => {
    setMailSent(false);
  };

  const onSuccess = () => {
    console.log(data);
    setMailSent(true);
    handleClose();
    setTimeout(timeOutFnc1, 2000);
  };

  const timeOutFnc1 = () => {
    setShowErrorPopup(false);
    fetchManufacturerList();
  };

  const onError = (err) => {
    console.log(err);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
    setTimeout(timeOutFnc1, 2000);
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={handleClose}
        dialogClassName="send-mail-modal"
        contentClassName="send-mail-modal col-6 mx-auto p-2 fn_Nunito"
      >
        <ModalBody>
          <div className="my-3 mt-4 text-center">
            <img src={verifyIcon} alt="icon" className="my-2" />
            <div>
              <span className="fn_Nunito fw_500 fs_22 my-2 px-0">
                Manufacturer Created Successfully
              </span>
            </div>
            {/* <p className="color_747f9e fs_14 col-10 mx-auto">
            Lorem ipsum dolor sit amet consectetur. Donec risus diam vitae risus
            sem leo ac quisque. Vestibulum pretium .
          </p> */}
            <p className="color_262c3d text-nowrap fs_14 fw_500 m-0">
              {data?.name}
            </p>
            <p className="color_262c3d text-nowrap fs_14 fw_500 m-0">
              {data?.employee_id}
            </p>
            <p className="color_262c3d text-nowrap fs_14 fw_500 m-0">
              {data?.email}
            </p>
          </div>

          <div className="d-flex justify-content-center align-items-center my-4 gap-2">
            <button
              type="button"
              className="modal-save-btn fs_14 text-white py-2 px-4 mx-3 fw_700"
              style={{ width: "150px" }}
              onClick={() => {
                handleClose();
              }}
            >
              Save
            </button>
            <button
              type="button"
              className="modal-cancel-btn fs_14 text-white py-2 px-4 mx-3 fw_700"
              style={{ width: "150px" }}
              onClick={() => sendMailFnc()}
            >
              Send Mail
            </button>
          </div>
        </ModalBody>
      </Modal>
      <MailSent show={mailSent} />
      <ErrorPopup show={showErrorPopup} title={showErrorMsg} />
    </>
  );
};

export default SendMailModal;
